<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter" id="prf2"><a id="page1"></a>PREFACE<br/><em>Anton</em></h1>
<p class="nonindent">I <span class="small">KNOW</span> where the path to the stars lies. The gate opened once, a long time ago and in a far and unlikely place. And then it closed. This is the story of how it opened and of how it closed and perhaps of what hinged upon it.</p>
<p class="indent">You see, Sharon Nagy was a physicist and Tom Schwoerin was a cliologist. That was the heart of the business right there. That was the beginning of it and the end of it and most of what happened in between.</p>
<p class="indent">Or perhaps you don’t, for the seeing was not easy. Medieval settlement patterns and multiple brane theory seem worlds apart. Indeed, they <em>are</em> worlds apart, tangent only in that small apartment in Philadelphia that Tom and Sharon shared. But at such close quarters they could not avoid learning a little of each other’s work, and that was the fulcrum on which they turned the world.</p>
<p class="indent">But I was into the affair last and least of all, and perhaps it would be best to let the story tell itself.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780765340351_epub_prf2_r1.vue?bc3ff8bc